// extracted by mini-css-extract-plugin
module.exports = {"SlideImage":"Banner_SlideImage__3S_U8","web":"Banner_web__28376","mob":"Banner_mob__3WHK5"};